import { fromJS } from 'immutable';
import { createStore } from 'reflux';
import SettingsActions from './settings_actions';
import WeatherStore from './weather_store';


const SettingsStore = createStore({

  listenables: [ SettingsActions ],

  init() {
    this.settings = fromJS({
      unlock_feature: false,
      showWeatherDetails: false,
      integration: 'rewarded',
      format: 'basic',
      pays: 'min $0.3',
      units: 'c'
    });
  },

  getInitialState() {
    return this.settings;
  },

  onGet() {
    this.trigger({ settings: this.settings });
  },

  onSet(key, value) {
    this.settings = this.settings.set(key, value);
    this.updatePays();
    this.updateUnlockFeature();
    this.updateWeatherDetails();
    this.updateWeather(key);
    this.updatePollfishState(key, value);
    this.trigger({ settings: this.settings });
  },

  updatePollfishState(key, value) {
    pollfishConfig.offerwall = false;
    if (key === 'integration' && value === 'rewarded') {
      /* eslint no-undef:0 */
      Pollfish.hide();
      Pollfish.start(pollfishConfig);
    }  else if (key === 'integration' && value === 'offerwall') {
      Pollfish.hide();
      pollfishConfig.offerwall = true;
      Pollfish.start(pollfishConfig);
    }
    if (key === 'format' && value === 'playful') {
      Pollfish.hide();
      pollfishConfig.survey_format = '1';
      Pollfish.start(pollfishConfig);
    } else if (key === 'format' && value === 'third-party') {
      Pollfish.hide();
      pollfishConfig.survey_format = '3';
      Pollfish.start(pollfishConfig);

      document.querySelector('body').onfocus = function () {
        Pollfish.hide();
        Pollfish.start(pollfishConfig);
      };
    } else if (key === 'format' && value === 'basic') {
      Pollfish.hide();
      pollfishConfig.survey_format = '0';
      Pollfish.start(pollfishConfig);
    }
  },

  updateWeather(key) {
    if (key === 'units') {
      WeatherStore.getWeatherInfo();
    }
  },

  updateWeatherDetails() {
    if (this.settings.get('integration') !== 'rewarded') {
      this.settings = this.settings.set('showWeatherDetails', false);
    }
  },

  updateUnlockFeature() {
    if (this.settings.get('integration') !== 'rewarded') {
      this.settings = this.settings.set('unlock_feature', false);
    }
  },

  updatePays() {
    let pays = 'min $0.3';
    if (this.settings.get('format') === 'playful') {
      pays = 'fluctuates';
    }
    this.settings = this.settings.set('pays', pays);
  }

});

export default SettingsStore;




// WEBPACK FOOTER //
// ./src/components/weather/settings_store.js